import React, { Component } from "react";
// import { reaction } from "mobx";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { isClientADesktop } from "../../../utils";
// import { Utils } from "arv-reactcomponents";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

import { Button } from "arv-reactcomponents";
import { STORE_LOCATOR_TIMINGS } from "npmlinks-constants";

@inject("StoreListStore", "ProductStore", "CommonStore")
@observer
class Store extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moreOptionsOpened: false,
    };
    this.storeClick = false;
    this.showMoreOptions = this.showMoreOptions.bind(this);
    this.showStoreOnTheMap = this.showStoreOnTheMap.bind(this);
    this.cleanProducts = this.cleanProducts.bind(this);
  }

  get moreOptionsClassName() {
    return this.state.moreOptionsOpened ? "is-active" : "";
  }
  get shopThisStore() {
    const { currentPincode } = this.props.StoreListStore;
    const radius = 20;
    const { fcId } = this.props.storeObj;
    return `/products?p-dl=${currentPincode}&f-dl=${currentPincode}&r=${radius}&f-ns=${fcId}`;
  }

  showMoreOptions(flag = false) {
    if (flag) {
      Analytics.trackEvent({
        action: Event.action.MORE_INFO_CLICK,
        category: Event.category.STORE_LOCATOR,
      });
    }
    this.setState({
      moreOptionsOpened: flag,
    });
  }

  showStoreOnTheMap(fcID) {
    Analytics.trackEvent({
      action: Event.action.STORE_UNIT_CLICK,
      category: Event.category.STORE_LOCATOR,
    });
    this.storeClick = true;
    this.props.StoreListStore.setSelectedStoreFCID(fcID);
  }

  cleanProducts() {
    Analytics.trackEvent({
      action: Event.action.SHOP_STORE_CLICK,
      category: Event.category.STORE_LOCATOR,
    });
    this.props.ProductStore.clearProductData();
  }

  get storesTiming() {
    const { openingTime, closingTime } = this.props.storeObj;
    const openTime = STORE_LOCATOR_TIMINGS.openingTime || openingTime;
    const closeTime = STORE_LOCATOR_TIMINGS.closingTime || closingTime;
    return ` ${openTime} -
    ${closeTime}`;
  }

  render() {
    const { isDesktop } = this.props.CommonStore;
    const contactNoList =
      this.props.storeObj.contactNo && this.props.storeObj.contactNo.split(",");
    const { moreOptionsOpened } = this.state;

    const showStore = (
      <div className="nw-store-actions nw-shopstore-action">
        <Link
          className="nw-store-shopthisstore"
          href={this.shopThisStore}
          to={this.shopThisStore}
        >
          <Button
            className="nw-store-shopthisstorebutton nwc-no-style-button"
            onClick={this.cleanProducts}
          >
            <i className="icomoon-shop-store" />
          </Button>
        </Link>
        <p>shop store</p>
      </div>
    );
    return (
      <li className={`nwc-store nwc-store-${this.props.storeObj.fcId}`}>
        <div
          className="nwc-store-toprow"
          onClick={() => this.showStoreOnTheMap(this.props.storeObj.fcId)}
          onKeyPress={() => this.showStoreOnTheMap(this.props.storeObj.fcId)}
          role="button"
          tabIndex="-1"
        >
          <span
            className="nw-store-ser-num"
            style={{ backgroundColor: this.props.storeObj.markerColor }}
          >
            {this.props.index + 1}
          </span>
          <span className="nw-store-distance">
            {Math.round(this.props.storeObj.distance * 100) / 100} km
          </span>
        </div>
        <div className="nw-store-details">
          {/* <Img src="" className="nw-store-image" /> */}
          <div className="nw-store-details-actions">
            <address
              className={`nw-store-desc nw-store-desc-${
                this.props.storeObj.fcId
              }`}
              onClick={() => this.showStoreOnTheMap(this.props.storeObj.fcId)}
              onKeyPress={() =>
                this.showStoreOnTheMap(this.props.storeObj.fcId)
              }
              role="button"
              tabIndex="-1"
            >
              <div className="nw-store-desc-fields nw-store-name ">
                {this.props.storeObj.fcName}
              </div>
              <div className="nw-store-desc-fields nw-store-address nw-store-sub-wrapper">
                <div>
                  {`${this.props.storeObj.streetNo &&
                    this.props.storeObj.streetNo.toLowerCase()},`}
                  {` ${this.props.storeObj.streetName &&
                    this.props.storeObj.streetName.toLowerCase()}`}
                  {`, ${this.props.storeObj.town &&
                    this.props.storeObj.town.toLowerCase()}-${
                    this.props.storeObj.postCode
                  }`}
                </div>
              </div>
            </address>
            <div
              className={`nw-store-more-heading clearfix ${
                this.moreOptionsClassName
              }`}
            >
              {this.props.storeObj.storeEnabled ? showStore : ""}
              <div className="nw-store-actions nw-info-action">
                <Button
                  className="nwc-btn nw-more-option nwc-no-style-button"
                  onClick={() => this.showMoreOptions(!moreOptionsOpened)}
                  onKeyPress={() => this.showMoreOptions(!moreOptionsOpened)}
                  onBlur={() => this.showMoreOptions(false)}
                >
                  <i className="icomoon-infooo">i</i>
                </Button>
                <p>
                  More Info
                  <span
                    className={`nw-tooltip-triagle ${
                      this.moreOptionsClassName
                    }`}
                  />
                </p>
                <div
                  className={`nw-store-desc-fields nw-store-hidden-details ${
                    this.moreOptionsClassName
                  }`}
                >
                  <div className="nw-store-phone">
                    <p>
                      <strong>Phone: </strong>
                    </p>
                    {contactNoList &&
                      contactNoList.map((no, index) => {
                        if (isDesktop) {
                          return (
                            <span className="" key={`${Math.random()}`}>
                              {no}
                              {`${
                                index < contactNoList.length - 1 &&
                                contactNoList.length > 1
                                  ? ", "
                                  : ""
                              }`}
                            </span>
                          );
                        }
                        return (
                          <a
                            className=""
                            href={`tel:${no}`}
                            key={`${Math.random()}`}
                          >
                            {no}
                            {`${
                              index < contactNoList.length - 1 &&
                              contactNoList.length > 1
                                ? ", "
                                : ""
                            }`}
                          </a>
                        );
                      })}
                  </div>
                  <div className="nw-store-timings">
                    <p>
                      <strong>Time: </strong>
                    </p>
                    <span>{this.storesTiming}</span>
                  </div>
                </div>
              </div>
              <div className="nw-store-actions nw-direction-action">
                <Button
                  className="nwc-no-style-button"
                  onClick={() =>
                    this.props.StoreListStore.gotoGoogleMaps(
                      this.props.storeObj.latitude,
                      this.props.storeObj.longitude,
                    )
                  }
                  onKeyPress={() =>
                    this.gotoGoogleMaps(
                      this.props.storeObj.latitude,
                      this.props.storeObj.longitude,
                    )
                  }
                >
                  <span className="nwc-store-direction-wrapper">
                    <i className="icomoon-get-direction" />
                  </span>
                </Button>
                <p>Get Direction</p>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  }
}

Store.wrappedComponent.propTypes = {
  storeObj: PropTypes.shape(PropTypes.shape({}).isRequired).isRequired,
  index: PropTypes.number.isRequired,
};

Store.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    clearProductData: PropTypes.func.isRequired,
  }).isRequired,
  StoreListStore: PropTypes.shape({
    currentPincode: PropTypes.string.isRequired,
    selectedStoreFCID: PropTypes.string,
    setSelectedStoreFCID: PropTypes.func.isRequired,
    gotoGoogleMaps: PropTypes.func.isRequired,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

const getFinalComponent = component =>
  inject("StoreListStore", "ProductStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: Store.wrappedComponent,
  component: Store,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StoreList/Store/index.js